import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a0324c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mobile-page-footer"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "footer-item flex-full",
  style: {
    "color": "white"
  }
};
const _hoisted_4 = {
  class: "item flex-row"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, "0755-28122809"), /*#__PURE__*/_createElementVNode("div", null, "0755-27990959")], -1));
const _hoisted_6 = {
  class: "item flex-row"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "darren@Waterboger.com", -1));
const _hoisted_8 = {
  class: "item flex-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Phone = _resolveComponent("Phone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Message = _resolveComponent("Message");
  const _component_Location = _resolveComponent("Location");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "footer-item flex-full"
    }, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(item.title)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (item1, index1) => {
      return _openBlock(), _createElementBlock("div", {
        class: "sub-title",
        key: index1
      }, _toDisplayString(_ctx.$t(item1)), 1);
    }), 128))]);
  }), 128)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Phone)]),
    _: 1
  }), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Message)]),
    _: 1
  }), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Location)]),
    _: 1
  }), _createElementVNode("div", null, _toDisplayString(_ctx.$t('location')), 1)])])]);
}